import { format_currency } from 'app/helpers/CurrencyHelpers'
import each from 'lodash/each'

export default {
  computed: {
    arsenals_subtotal () {
      const pledge = this.order.products.pledge

      const standardPrice = (!pledge && this.order.product_prices?.arsenal_2_standard.sale) || this.prices.arsenal_2_standard.sale
      const proPrice = (!pledge && this.order.product_prices?.arsenal_2_pro.sale) || this.prices.arsenal_2_pro.sale

      let subtotal = (standardPrice * this.order.products.arsenal.quantity)
                   + (proPrice * this.order.products.arsenal_pro.quantity)

      if (pledge && pledge.quantity > 0) {
        if (pledge.arsenal_model == 'Arsenal 2 Standard') {
          subtotal += standardPrice * pledge.quantity
        } else {
          subtotal += proPrice * pledge.quantity
        }
      }
      return subtotal
    },
    cables_subtotal () {
      let sum = 0
      if (this.order.products.pledge) {
        each(this.order.products.pledge.cables, (cable, index) => {
          if (index >= this.order.products.pledge.quantity) {
            sum += 10
          }
        })
      }
      each(this.order.products.arsenal.cables, (cable, index) => {
        if (index >= this.order.products.arsenal.quantity) {
          sum += 10
        }
      })
      each(this.order.products.arsenal_pro.cables, (cable, index) => {
        if (index >= this.order.products.arsenal_pro.quantity) {
          sum += 10
        }
      })
      return sum
    },
    accessories_subtotal () {
      const phoneMountPrice = this.order.product_prices?.phone_mount.sale || this.prices.phone_mount.sale
      const batteryPrice = this.order.product_prices?.battery.sale || this.prices.battery.sale
      const microSdCardPrice = this.order.product_prices?.micro_sd_card.sale || this.prices.micro_sd_card.sale

      return (phoneMountPrice * this.order.products.phone_mount.quantity)
        + (batteryPrice * this.order.products.battery.quantity)
        + (microSdCardPrice * this.order.products.micro_sd_card.quantity)
    },
    subtotal () {
      return this.arsenals_subtotal + this.cables_subtotal + this.accessories_subtotal
    },
    shipping () {
      if (this.order.id) {
        return this.order.shipping
      }

      // Hide shipping unless we have a shipping address or a method
      if (!this.order.shipping_address.address_1 && !this.order.shipping_method) {
        return null
      }

      if (this.order.shipping_method && this.order.shipping_method.id) {
        return this.order.shipping_method.id ? this.order.shipping_method.price_cents / 100 : 0
      } else {
        const country = this.express_checkout ? this.express_checkout_data.shipping_country : this.order.shipping_address.country
        return country == 'United States of America' ? this.prices.standard_shipping : this.prices.international_shipping
      }
    },
    calculated_promo_code_discount () {
      let discount = 0
      if (this.order.promo_code && this.order.promo_code.valid) {
        if (this.order.promo_code.discount_amount_cents) {
          discount = this.order.promo_code.discount_amount_cents / 100
        } else {
          const sale_price_discount =
            (this.prices.arsenal_2_standard.retail * this.order.products.arsenal.quantity)
            + (this.prices.arsenal_2_pro.retail * this.order.products.arsenal_pro.quantity)
            - (this.prices.arsenal_2_standard.sale * this.order.products.arsenal.quantity)
            - (this.prices.arsenal_2_pro.sale * this.order.products.arsenal_pro.quantity)
          const promo_code_discount = (
            (this.prices.arsenal_2_standard.retail * this.order.products.arsenal.quantity) +
            (this.prices.arsenal_2_pro.retail * this.order.products.arsenal_pro.quantity)
          ) * (this.order.promo_code.discount_percentage / 100)
          discount = promo_code_discount > sale_price_discount ? promo_code_discount - sale_price_discount : 0
        }
      }
      return discount
    },
    promo_code_discount () {
      return this.calculated_promo_code_discount > 0 ? this.format_currency(this.calculated_promo_code_discount) : null
    },
    calculated_tax () {
      if (this.order.tax_rate === null || this.order.tax_rate === 0) {
        return 0
      }

      let taxable_amount = this.subtotal - this.calculated_promo_code_discount
      if (this.order.shipping_taxable) {
        taxable_amount += this.shipping
      }

      return taxable_amount * this.order.tax_rate
    },
    tax () {
      return this.order.tax_rate != null ? this.format_currency(this.calculated_tax) : null
    },
    raw_total () {
      let total = this.subtotal + this.shipping - this.calculated_promo_code_discount
      if (this.order.tax_rate != null) {
        total = total + this.calculated_tax
      }
      if (this.order.status == 'Pledge') {
        total = total - this.order.charged_amount
      }
      return total
    },
    total () {
      return this.format_currency(this.raw_total)
    },
    amount_due () {
      let total = this.subtotal + this.shipping - this.calculated_promo_code_discount
      if (this.order.tax_rate != null) {
        total = total + this.calculated_tax
      }
      return total - this.order.charged_amount
    }
  },
  methods: {
    format_currency,
    default_shipping_for_country (country) {
      if (country == 'United States of America' || country == 'US') {
        return this.prices.standard_shipping
      } else {
        return this.prices.international_shipping
      }
    }
  }
}
